import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import * as debug from '../services/debug.service';
import { LoggingService } from '../services/logging.service';
import { NotificationService } from '../services/notification.service';
import { MenuService } from '../services/menu.service';
import { OnlineOfflineService } from '../services/online-offline.service';
import { appUrl } from 'src/environments/environment';
// import { ErrorDbService } from '../services/error-db.service';
import { SecurityService } from '../services/security.service';
import { parseErrorMessage } from './utility.common';
import { environment } from 'src/environments/environment';

const MAX_DUPLICATE_COUNT = 5;

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {

	duplicateCount = 0;
	oldError = '';

	constructor(private readonly logger: LoggingService
		, private readonly menuService: MenuService
		, private readonly notificationService: NotificationService
		, private readonly onlineOfflineService: OnlineOfflineService
		, private readonly securityService: SecurityService // force load
	) {
		debug.log('006 GlobalErrorHandler instantiated');
		this.registerToEvents(this.onlineOfflineService);
	}

	private registerToEvents(onlineOfflineService: OnlineOfflineService) {
		onlineOfflineService.connectionChanged.subscribe(online => {
			this.menuService.isNetworkOnline = online;
			if (online) {
				debug.log('091 Online.. Calling sendStoredErrors');
				this.logger.sendStoredErrors(`GlobalErrorhandler constructor`);
				this.notificationService.showSuccess('You are now back online.');
			} else {
				this.notificationService.showError('No Internet Connection.');
			}
		});
	}

	async handleError(error: Error | HttpErrorResponse) {
		const isProfileUrl = this.isProfileUrl(error);

		if (isProfileUrl) {
			return Promise.resolve();
		}

		if (environment.production) {
			const pattern = /ExpressionChangedAfterItHasBeenCheckedError/gi;
			if (pattern.test(error.message)) {
				return Promise.resolve();
			}
		}

		let message = '';

		if (error instanceof HttpErrorResponse) {
			message = error.error;
		} else {
			message = parseErrorMessage(error);
		}

		debug.log(`GlobalErrorHandler.handle message: ${message}`);

		if (!!this.oldError && this.oldError === message) {
			this.duplicateCount++;
			if (this.duplicateCount > MAX_DUPLICATE_COUNT) {
				const newMsg = `Consecutive identical errors have reached its maximum count: ${MAX_DUPLICATE_COUNT}. Exiting... ${message}`;
				const e = new Error(newMsg);
				debug.log(`GlobalErrorHandler.handle. newMsg: ${newMsg}`);
				this.notificationService.showError(`Consecutive identical errors have reached its maximum count: ${MAX_DUPLICATE_COUNT}`);
				return this.logger.logError(e, `GlobalErrorhandler.handle MAX_DUPLICATE_COUNT`);
			}
			this.oldError = message;
		} else {
			this.duplicateCount = 0;
		}

		// if (message.indexOf(`getIDBObjectStore`) > 0) {
		//     // this.securityService.completeLogout();
		//     this.securityService.logout();
		//    //  this.router.navigate(['/signout-callback'], { replaceUrl: true });
		//     // // this.securityService.logout();
		//     // // app-signout-redirect-callback
		// }

		this.notificationService.showError(message);

		return this.logger.logError(error, `GlobalErrorhandler.handle`);

		// // Always log errors
		// return this.logger.logError(error, `GlobalErrorhandler.handle`)
		//     .then(() => {
		//         debug.log('GlobalErrorhandler.handle isBusy = false');
		//         this.menuService.setIsBusy(false);
		//     });
	}

	private isProfileUrl(error: Error | HttpErrorResponse): boolean {
		return !!error && !!error.message && error.message.toString().indexOf(appUrl.userProfile) > 0;
	}
}
